import script from "./CossCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./CossCompleted.vue?vue&type=script&setup=true&lang=js"

import "./CossCompleted.vue?vue&type=style&index=0&id=ec43b498&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec43b498"]])

export default __exports__